import { getRequestOptions4ConvoAI } from './request-options-convo-ai';
import { getRequestOptions4RovoChat } from './request-options-rovo-agent';
import { getRequestOptions4XPGenAI, shouldUseXPGenAI } from './request-options-xp-gen-ai';
export function getRequestOptions(_ref) {
  var callback = _ref.callback,
    context = _ref.context,
    configItem = _ref.configItem,
    mentionMap = _ref.mentionMap;
  // elevate free generate is disabled and returns the pre-configured response immediately
  if (configItem.response) {
    return {
      response: configItem.response
    };
  }
  var latestPromptResponse = context.latestPromptResponse;
  var intentSchemaId = typeof configItem.intentSchemaId === 'function' ? configItem.intentSchemaId({
    latestPromptResponse: latestPromptResponse
  }) : configItem.intentSchemaId;
  var updateIdMap = function updateIdMap(_ref2) {
    var idMap = _ref2.idMap;
    callback({
      type: 'update idMap',
      context: {
        idMap: idMap
      }
    });
  };
  var requestOptions;
  if (shouldUseXPGenAI({
    configItem: configItem,
    latestPromptResponse: latestPromptResponse
  })) {
    requestOptions = getRequestOptions4XPGenAI({
      context: context,
      configItem: configItem,
      mentionMap: mentionMap,
      intentSchemaId: intentSchemaId,
      updateIdMap: updateIdMap
    });
  } else if (configItem.agent) {
    requestOptions = getRequestOptions4RovoChat({
      context: context,
      configItem: configItem,
      mentionMap: mentionMap,
      updateIdMap: updateIdMap
    });
  } else {
    requestOptions = getRequestOptions4ConvoAI({
      context: context,
      configItem: configItem,
      mentionMap: mentionMap,
      intentSchemaId: intentSchemaId,
      updateIdMap: updateIdMap
    });
  }
  if ('contentStatistics' in requestOptions && requestOptions.contentStatistics) {
    callback({
      type: 'storeContextStatistics',
      contextStatistics: {
        inputDocument: requestOptions.contentStatistics
      }
    });
  }
  return requestOptions;
}